import { useCreationStore } from '../../lib/creationStore'
import { useRefSpecies, useRefCultures } from '../../hooks/useRefData'

export function StepIdentity() {
  const store = useCreationStore()
  const { data: species } = useRefSpecies()
  const { data: cultures } = useRefCultures()

  return (
    <div>
      <h3>Step 1: Identity</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label>Character Name</label><br />
          <input value={store.name} onChange={e => store.setField('name', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }} required />
        </div>
        <div>
          <label>Role</label><br />
          <select value={store.characterRole} onChange={e => store.setField('characterRole', e.target.value as 'pc' | 'npc')}
            style={{ width: '100%', padding: '0.4rem' }}>
            <option value="pc">Player Character</option>
            <option value="npc">NPC</option>
          </select>
        </div>
        <div>
          <label>Species</label><br />
          <select value={store.species_id} onChange={e => store.setField('species_id', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {species?.map(s => <option key={s.species_id} value={s.species_id}>{s.display_name}</option>)}
          </select>
        </div>
        <div>
          <label>Sex</label><br />
          <select value={store.sex} onChange={e => store.setField('sex', e.target.value as 'Male' | 'Female')}
            style={{ width: '100%', padding: '0.4rem' }}>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <div>
          <label>Culture</label><br />
          <select value={store.culture_id} onChange={e => store.setField('culture_id', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {cultures?.map(c => <option key={c.culture_id} value={c.culture_id}>{c.display_name}</option>)}
          </select>
        </div>
        <div>
          <label>Social Class</label><br />
          <select value={store.social_class} onChange={e => store.setField('social_class', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {['Slave','Serf','Unguilded','Guilded','Noble'].map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      </div>
    </div>
  )
}
